var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reviews-container" }, [
    _c("div", { staticClass: "reviews-header" }, [
      _c("h2", [_vm._v("Customer Reviews")]),
      _vm._v(" "),
      _vm.overallRating
        ? _c("div", { staticClass: "overall-rating-wrap" }, [
            _c("div", { staticClass: "overall-rating" }, [
              _c("span", { staticClass: "rating-number" }, [
                _vm._v(_vm._s(_vm.overallRating.toFixed(1)))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "stars" }, [
                _vm._v(_vm._s(_vm.getStars(Math.round(_vm.overallRating))))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "total-reviews" }, [
              _vm._v("Based on " + _vm._s(_vm.totalReviews) + " reviews")
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [_vm._v("Loading reviews...")])
      : _vm.error
      ? _c("div", { staticClass: "error" }, [
          _vm._v("\n        " + _vm._s(_vm.error) + "\n        "),
          _vm.errorDetails
            ? _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "0.85em",
                    "margin-top": "10px",
                    color: "#666"
                  }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.errorDetails) + "\n        "
                  )
                ]
              )
            : _vm._e()
        ])
      : _vm.filteredReviews.length > 0
      ? _c(
          "div",
          { staticClass: "reviews-grid" },
          _vm._l(_vm.filteredReviews, function(review) {
            return _c("div", { key: review.name, staticClass: "review-card" }, [
              _c("div", { staticClass: "review-header" }, [
                _c("img", {
                  staticClass: "reviewer-photo",
                  attrs: {
                    src: _vm.getPhotoUrl(review),
                    alt: _vm.getAuthorName(review)
                  },
                  on: { error: _vm.handleImageError }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "reviewer-info" }, [
                  _c("div", { staticClass: "reviewer-name" }, [
                    _vm._v(_vm._s(_vm.getAuthorName(review)))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-date" }, [
                    _vm._v(_vm._s(_vm.getPublishTime(review)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "review-rating" }, [
                _vm._v(_vm._s(_vm.getStars(_vm.getRating(review))))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "review-text" }, [
                _vm._v(_vm._s(_vm.getReviewText(review)))
              ])
            ])
          }),
          0
        )
      : _c("div", { staticClass: "loading" }, [
          _vm._v("No reviews available.")
        ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "google-link" }, [
      _c(
        "a",
        {
          attrs: {
            href:
              "https://search.google.com/local/writereview?placeid=ChIJPbKWYoh3flMR8x7e6sYr9Mo",
            target: "_blank",
            rel: "noopener"
          }
        },
        [_vm._v("\n            Write a Review on Google\n        ")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38c50bce", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c50bce","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./html/js/src/common/google_reviews.vue
// module id = y9dq
// module chunks = 0